var cloudinaryUrl = 'https://digitalassets-accounts.tesla.com/image/upload/f_auto,q_auto/accountos/public/images/tesla';
var assetUrl = 'https://digitalassets.tesla.com/image/upload';
var imageUrls = {
  DIGITAL_ASSETS_URL: 'https://digitalassets.tesla.com/image/upload/f_auto,q_auto/stage/coin/static_assets/',
  STATIC_ASSET: '/configurator/compositor',
  POWERWALL: "".concat(cloudinaryUrl, "/energy-powerwall"),
  'POWERWALL PLUS': "".concat(cloudinaryUrl, "/energy-powerwall-plus"),
  'PV SYSTEM': "".concat(cloudinaryUrl, "/energy-solar-panel"),
  'SOLAR PANELS': "".concat(cloudinaryUrl, "/energy-solar-panel.png"),
  'SOLAR ROOF': "".concat(cloudinaryUrl, "/energy-solar-roof.png"),
  STACKED_VEHICLE: "".concat(cloudinaryUrl, "/vehicle-stacked"),
  STACKED_ENERGY: "".concat(cloudinaryUrl, "/energy-stacked"),
  DEFAULT_VEHICLE_IMAGE: "".concat(cloudinaryUrl, "/vehicle-placeholder"),
  DEFAULT_ENERGY_IMAGE: "".concat(cloudinaryUrl, "/energy-stacked"),
  ECOMMERCE_ONLY: "".concat(cloudinaryUrl, "/commerce-only.png"),
  STORAGE: "".concat(cloudinaryUrl, "/energy-powerwall.png"),
  ROADSTER_RD_IMAGE: "".concat(assetUrl, "/roadster_front_b3865b5185d0a.png"),
  ROADSTER_MT_IMAGE: "".concat(assetUrl, "/cybertruck_636x300_c7cd4fb84ad.jpg"),
  CYBERTRUCK_IMAGE: "".concat(assetUrl, "/roadster_side_view_1aaf409d6c4b1.png")
};

export { imageUrls as default };
